// extracted by mini-css-extract-plugin
module.exports = {"efPagination":"pagination_efPagination__EScvM"};